module.exports = __webpack_public_path__ + "media/src/images/arrow-5c0f90a57d85d4e47f9bb80ba29d836a.svg";